import React, { FC } from 'react';
import { useDrawerSearchFilterNameOrCategory } from '@minecraft.drawer';
import { AGE_LIMIT, CD_AGE_LIMIT } from '../../../shared/config';
import { FiltersNameEnum } from '../../../shared/types';
import { FormItem } from '../../../shared/styles';
import { AgeRange } from '../../../FilterCollection';
import { FilterDrawerType, FiltersCategoryNameEnum } from '../../shared/types';
import { useFiltersLabel } from '../../shared/hooks/useFiltersLabel';

interface Props {
  isCasting: boolean;
  isReps: boolean;
  type: FilterDrawerType;
}

const AgeCategory: FC<Props> = ({ isCasting, isReps, type }) => {
  const filtersLabelOfAudience = useFiltersLabel(type);

  const { isCategoryMatchedSearch, shouldCategoryFilterBeVisible } = useDrawerSearchFilterNameOrCategory(
    FiltersCategoryNameEnum.age
  );

  return (
    isCategoryMatchedSearch && (
      <>
        {shouldCategoryFilterBeVisible(FiltersNameEnum.playableAgeRange) && (
          <FormItem $fullWidth $marginValue={2}>
            <AgeRange
              ageRangeName={FiltersNameEnum.playableAgeRange}
              switchAgeToMonthsName={FiltersNameEnum.switchTo}
              ageMinName={FiltersNameEnum.min}
              ageMaxName={FiltersNameEnum.max}
              label={filtersLabelOfAudience[FiltersNameEnum.playableAgeRange]}
              ageLimit={AGE_LIMIT}
            />
          </FormItem>
        )}
        {isCasting && shouldCategoryFilterBeVisible(FiltersNameEnum.minorsAgeRange) && (
          <FormItem $fullWidth $marginValue={2}>
            <AgeRange
              ageRangeName={FiltersNameEnum.minorsAgeRange}
              switchAgeToMonthsName={FiltersNameEnum.switchTo}
              ageMinName={FiltersNameEnum.min}
              ageMaxName={FiltersNameEnum.max}
              label={filtersLabelOfAudience[FiltersNameEnum.minorsAgeRange]}
              ageLimit={CD_AGE_LIMIT}
            />
          </FormItem>
        )}
        {isReps && shouldCategoryFilterBeVisible(FiltersNameEnum.realAgeRange) && (
          <FormItem $fullWidth $marginValue={2}>
            <AgeRange
              ageRangeName={FiltersNameEnum.realAgeRange}
              switchAgeToMonthsName={FiltersNameEnum.switchTo}
              ageMinName={FiltersNameEnum.min}
              ageMaxName={FiltersNameEnum.max}
              label={filtersLabelOfAudience[FiltersNameEnum.realAgeRange]}
              ageLimit={AGE_LIMIT}
            />
          </FormItem>
        )}
      </>
    )
  );
};

export default AgeCategory;
